export default __webpack_public_path__ + "static/media/4.38b0c0eb.gif";